videojs.addLanguage('da', 
 {
  "Play": "Play",
  "Pause": "Pause",
  "Current Time": "Current Time",
  "Duration Time": "Duration Time",
  "Remaining Time": "Remaining Time",
  "Stream Type": "Stream Type",
  "LIVE": "LIVE",
  "Loaded": "Loaded",
  "Progress": "Progress",
  "Fullscreen": "Fullscreen",
  "Non-Fullscreen": "Non-Fullscreen",
  "Mute": "Mute",
  "Unmuted": "Unmuted",
  "Playback Rate": "Playback Rate",
  "Subtitles": "Undertekster",
  "subtitles off": "Undertekster fra",
  "Captions": "Captions",
  "captions off": "captions off",
  "Chapters": "Chapters",
  "You aborted the video playback": "You aborted the video playback.",
  "A network error caused the video download to fail part-way.": "Videoafspilningen forsvandt pludselig, kontrollér venligst din internetforbindelse.",
  "The video could not be loaded, either because the server or network failed or because the format is not supported.": "Filmfilen er defekt, eller også understøttes formatet ikke af din browser.",
  "The video playback was aborted due to a corruption problem or because the video used features your browser did not support.": "Denne filmfil er enten ikke tilgængelig, eller også understøttes formatet ikke af din browser.",
  "No compatible source was found for this video.": "Ingen film er indlæst."
});